export class MensagemOrcamentoModel {
  constructor({
    id,
    sequencia,
    titulo,
    classificacao,
    descricao,
    flagObrigatorio = false,
    criterios = false,
    obrigatorio,
  }) {
    this.id = id;
    this.titulo = titulo;
    this.sequencia = sequencia;
    this.classificacao = classificacao;
    this.descricao = descricao;
    this.flagObrigatorio = flagObrigatorio;
    this.criterios = criterios
    this.obrigatorio = obrigatorio === 'Sim' ? true : obrigatorio === 'Nao' ? false : obrigatorio;
  }
}
